export enum Integrations {
  LiveSquare = 'LVSQ',
  CommonFloor = 'CMFL',
  NNAcres = 'NNAS',
  Housing = 'HSNG',
  MagicBricks = 'MCBS',
  Makaan = 'MAKN',
  Quikr = 'QUKR'
}
